import {TextField} from "../styles/config";
import React from "react";
import {CircularProgress} from "@material-ui/core";
import {Autocomplete as AutoCompleteWidget} from "@material-ui/lab";
import {injectIntl} from "react-intl";

const AutoComplete = (props) => {

    const {label, handleOnChange, handleInputChange, optionsList = [], isLoading = false, multiple = true} = props;

    return (
        <AutoCompleteWidget
            onInputChange={(e, value, reason) => {
                if (value.trim().length) {
                    handleInputChange(e, value, reason);
                }
            }}
            multiple={multiple}
            className="col-lg-6 bg-light border-0"
            id="tags-outlined"
            noOptionsText={'Search Options'}
            options={optionsList}
            getOptionLabel={(option) => option.title}
            filterSelectedOptions
            style={{width: 300, flex: '0 0 49%', padding: 0, margin: '.5%'}}
            variant="outlined"
            onChange={handleOnChange}
            getOptionSelected={(option, value) => option.id === value.id}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    variant="outlined"
                    fullWidth
                    className="col-lg-3"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {isLoading ? <CircularProgress color="inherit" size={20}/> : <></>}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
};

export default injectIntl(AutoComplete);
